var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('FacilityEditCities',{attrs:{"facility":_vm.facility}}),_c('v-divider',{staticClass:"mt-8 mb-6"}),_c('FacilityEditAddressPostal',{attrs:{"facility":_vm.facility}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }